import { Button, Input, InputGroup, SelectPicker } from 'rsuite';

import styles from './CompetitivenessFilter.module.scss';
import { COMPETITIVITY_MENU_ITEMS } from '../../constants';
import { isBetween, validateCpiFilter, type CpiFilterOperator, type CpiFilterState } from './competitivenessFilter.utils';

export type CompetitivenessFilterProps = {
  title: string;
  value: CpiFilterState;
  onChange: (value: CpiFilterState) => void;
  onApply: () => void;
  onClear: () => void;
  testIdPrefix?: string;
  onSelectOpenChange?: (open: boolean) => void;
};

const percentAddon = (
  <InputGroup.Addon>
    <span>%</span>
  </InputGroup.Addon>
);

export const CompetitivenessFilter = ({
  title,
  value,
  onChange,
  onApply,
  onClear,
  testIdPrefix = 'cpi-filter',
  onSelectOpenChange,
}: CompetitivenessFilterProps) => {
  const { canApply, message } = validateCpiFilter(value);
  const between = isBetween(value.operator);

  const handleOperatorChange = (operator: CpiFilterOperator | null) => {
    if (operator) {
      onChange({ ...value, operator });
    }
  };

  return (
    <div data-testid={`${testIdPrefix}-panel`}>
      <div className={styles.titleWrapper}>
        <p>{title}</p>
      </div>
      <div className={styles.inputWrapper}>
        <SelectPicker
          searchable={false}
          cleanable={false}
          data={COMPETITIVITY_MENU_ITEMS}
          value={value.operator}
          placeholder="Selecione"
          onChange={handleOperatorChange}
          onOpen={() => onSelectOpenChange?.(true)}
          onClose={() => onSelectOpenChange?.(false)}
        />
        {between ? (
          <>
            <InputGroup className={styles.inputGroup}>
              <Input
                type="number"
                aria-label="Valor de competitividade inicial"
                data-testid={`${testIdPrefix}-from`}
                value={value.from}
                onChange={from => onChange({ ...value, from })}
              />
              {percentAddon}
            </InputGroup>
            <span>e</span>
            <InputGroup className={styles.inputGroup}>
              <Input
                type="number"
                aria-label="Valor de competitividade final"
                data-testid={`${testIdPrefix}-to`}
                value={value.to}
                onChange={to => onChange({ ...value, to })}
              />
              {percentAddon}
            </InputGroup>
          </>
        ) : (
          <>
            <span>a</span>
            <InputGroup className={styles.inputGroup}>
              <Input
                type="number"
                aria-label="Valor de competitividade"
                data-testid={`${testIdPrefix}-from`}
                value={value.from}
                onChange={from => onChange({ ...value, from })}
              />
              {percentAddon}
            </InputGroup>
          </>
        )}
      </div>
      {message && (
        <div className={styles.error} role="alert" data-testid={`${testIdPrefix}-error`}>
          {message}
        </div>
      )}
      <div className={styles.actions}>
        <Button appearance="subtle" onClick={onClear} data-testid={`${testIdPrefix}-clear`}>
          Limpar
        </Button>
        <Button appearance="primary" disabled={!canApply} onClick={onApply} data-testid={`${testIdPrefix}-apply`}>
          Aplicar
        </Button>
      </div>
    </div>
  );
};
